module.exports = __webpack_public_path__ + "img/no-adoptions-sent.be448a4c.svg";